import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const isRequiredOption = ({value, options}) => {
  let required = false
  options.forEach((option) => {
    required = required || (option.value === value && option.required)
  })
  return required
}

class RFMultiCheckbox extends React.Component {
  render(){
    const {options} = this.props

    return [options.map(this._checkbox)]
  }

  _checkbox = ({label,value, description, required}, idx) => {
    return <div key={idx} className="c-doorkeeper-applications-form__application_form_scope_checkboxes mb-25px">
      <div className="c-doorkeeper-applications-form__application_form_scope_checkboxes_checkbox">
        <input
            type="checkbox"
            className="__checkbox_scopes"
            checked={this._isChecked(value)}
            onChange={() => this._onCheck(value)}
            disabled={required}
        />
      </div>
      <div className="c-doorkeeper-applications-form__application_form_scope_checkboxes_content">
        <div className="c-doorkeeper-applications-form__application_form_scope_checkboxes_label">
          {label}
        </div>
        <div className="c-doorkeeper-applications-form__application_form_scope_checkboxes_desc">
          {description}
        </div>
      </div>
    </div>
  }

  _isChecked = (optionValue) => {
    const {input: {value}, deserializer} = this.props
    const deserializedValues = deserializer(value)
    return deserializedValues.includes(optionValue)
  }

  _onCheck = (optionValue) => {
    const {input: {value, onChange}, deserializer, serializer, options} = this.props
    let deserializedValues = deserializer(value)

    if (_.includes(deserializedValues,optionValue)){
      if (!isRequiredOption({value: optionValue, options})){
        deserializedValues = _.filter(deserializedValues,v => v !== optionValue)
        onChange(serializer(deserializedValues))
      }
    } else {
      deserializedValues.push(optionValue)
      onChange(serializer(deserializedValues))
    }
  }

}

RFMultiCheckbox.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    description: PropTypes.string
  })),
  serializer: PropTypes.func,
  deserializer: PropTypes.func
}

export {RFMultiCheckbox}




// WEBPACK FOOTER //
// app/javascript/components/fields/MultiCheckbox/MultiCheckbox.js